import http from "../http";

export const getCollections = (storeId) => {
  return http.get(`/store-management/collections/?store_id=${storeId}`);
};

export const createCollection = (storeId, data) => {
  return http.post(`/store-management/collections/?store_id=${storeId}`, data);
};

export const deleteCollection = (storeId, id) => {
  return http.delete(
    `/store-management/collections/${id}/?store_id=${storeId}`,
  );
};
